import { useTranslation } from 'react-i18next';
import { Typography as MuiTypography } from '@mui/material';
import LoadingPage from 'components/LoadingPage';
import { format, parseISO } from 'date-fns';
import { getQuestionnaireResponseEndDate } from '.';
import { dateFnsLocales } from 'lib/utils/getDateFnsLocales';
import QuestionnaireAnswerItem from './QuestionnaireAnswerItem';

const Footer = (props) => {
  const {
    selected,
    isQuestionnaire,
    questionnaireAnswers,
    metricDefinitionId,
    loading,
    onSeeAnswers,
    patientId
  } = props;
  const { t, i18n } = useTranslation();
  const locale = dateFnsLocales[i18n.language];

  const getFooterTitle = () => {
    return selected?.aggregationPeriod !== 'DAILY'
      ? t('Questionnaires answered between {{startDate}} and {{endDate}}', {
          startDate: selected?.date
            ? `${format(parseISO(selected?.date), 'PPP', {
                locale,
              })}`
            : '-',
          endDate:
            selected?.aggregationPeriod && selected?.date
              ? `${format(
                  parseISO(
                    getQuestionnaireResponseEndDate(
                      selected?.aggregationPeriod,
                      selected?.date
                    )
                  ),
                  'PPP',
                  {
                    locale,
                  }
                )}`
              : '-',
        })
      : t('Questionnaires answered in {{date}}', {
          date: selected?.date
            ? `${format(parseISO(selected?.date), 'PPP', {
                locale,
              })}`
            : '-',
        });
  };

  const getFooterTitleWithoutSelection = () =>
    t('Questionnaires answered between {{startDate}} and {{endDate}}', {
      startDate: selected?.startDateTime
        ? `${format(parseISO(selected?.startDateTime), 'PPP', {
            locale,
          })}`
        : '-',
      endDate: selected.endDateTime
        ? `${format(parseISO(selected.endDateTime), 'PPP', {
            locale,
          })}`
        : '-',
    });

  return (
    <>
      {isQuestionnaire && questionnaireAnswers && (
        <>
          <MuiTypography
            style={{ marginTop: '30px' }}
            variant="h5"
            color="textPrimary"
          >
            {selected?.date
              ? getFooterTitle() + ':'
              : getFooterTitleWithoutSelection() + ':'}
          </MuiTypography>
          {loading ? (
            <LoadingPage style={{ height: 150, flex: 1 }} />
          ) : (
            questionnaireAnswers.map((questionnaireAnswer) => (
              <QuestionnaireAnswerItem
                key={
                  questionnaireAnswer?.id + '-' + questionnaireAnswer?.version
                }
                questionnaireAnswer={questionnaireAnswer}
                metricDefinitionId={metricDefinitionId}
                onSeeAnswers={onSeeAnswers}
                locale={locale}
                patientId={patientId}
              />
            ))
          )}
        </>
      )}
    </>
  );
};

export default Footer;
